import { useId } from "react"

import { Form, Select } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CloudConnectionFields } from "@/pages/DeploymentsPage/components/molecules/CloudConnectionStatus"

import type { CopilotStudioSettingsFieldsProps } from "."

// Kodem enforces on Copilot Studio through its threat detection webhook only,
// always on: the environments are the only setting.
export const CopilotStudioSettingsFields = ({
  value,
  onChange
}: CopilotStudioSettingsFieldsProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.copilotStudio.fields"
  })
  const id = useId()
  const set = (patch: Partial<typeof value>) => onChange({ ...value, ...patch })

  return (
    <CloudConnectionFields>
      <Form.Item
        label={t("environmentIds.label")}
        help={t("environmentIds.help")}
        htmlFor={`${id}-environments`}
      >
        <Select
          id={`${id}-environments`}
          mode="tags"
          open={false}
          suffixIcon={null}
          tokenSeparators={[",", " "]}
          value={value.environmentIds}
          placeholder={t("environmentIds.placeholder")}
          onChange={(environmentIds: string[]) => set({ environmentIds })}
        />
      </Form.Item>
    </CloudConnectionFields>
  )
}
